import { render, staticRenderFns } from "./RefundPolicy.vue?vue&type=template&id=1884bd2c&scoped=true&"
import script from "./RefundPolicy.vue?vue&type=script&lang=js&"
export * from "./RefundPolicy.vue?vue&type=script&lang=js&"
import style0 from "./RefundPolicy.vue?vue&type=style&index=0&id=1884bd2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1884bd2c",
  null
  
)

export default component.exports